'use client'
import { Common, Enums, Messages, NumericFormat, Skeleton } from '@/config/NextImport'
import useScreenWidth from '@/hooks/useScreenWidth'
import Slider from 'rc-slider'
import React, { useEffect, useRef, useState } from 'react'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'rc-slider/assets/index.css'
import 'react-loading-skeleton/dist/skeleton.css'
import 'swiper/css'
import 'swiper/css/navigation'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useSelector } from 'react-redux'
import { AppState } from '@/lib/store'
import Cookies from 'js-cookie'
import Tooltip from 'rc-tooltip'
import GoogleReviewBanner from '../home/GoogleReviewBanner'
import parse from 'html-react-parser'

const handleSlider = (node: React.ReactElement, props: any) => {
  const { value, dragging, index, prefixCls, draggingDelete, ...restProps } = props

  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={`${parseFloat(value)}`}
      visible={dragging}
      placement="top"
      key={index}
    >
      {React.cloneElement(node, restProps)}
    </Tooltip>
  )
}

const getCountryKey = () => {
  const countryId = Cookies.get(Messages.Country)

  switch (countryId) {
    case '6':
      return 'AUD'
    case '7':
      return 'CAD'
    case '9':
      return 'UK'
    case '8':
      return 'USA'
    case '11':
      return 'NZ'
    default:
      return 'UK'
  }
}

const Filter = (props: any) => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()
  const screenWidth = useScreenWidth()
  const { current: Filters } = useRef<any>(props?.filterData[0] || [])

  // currency
  const countryKey = getCountryKey()
  const priceFilter = Filters.find((x: any) => x.attribute_code === 'price')
  const countryPrice = priceFilter?.country_price?.[countryKey]
  const priceMin = countryPrice?.min
  const priceMax = countryPrice?.max

  const { current: MobileFilters } = useRef<any>(Common.chunk(props.filterData[0], 3) || [])
  const [ShowFilterValue, setShowFilterValue] = useState<any>(props.queryParams)
  const SliderValues = Object.fromEntries(
    props.filterData[0]
      .filter((item: { input_type: string }) => item.input_type === Enums.Controltype.Slider)
      .map((item: any) => {
        const attribute = item.attribute_code
        if (attribute === 'price' && priceMin && priceMax) {
          const value = ShowFilterValue[attribute]
          const range = value ? value.split('-') : [priceMin, priceMax]

          return [attribute, [parseFloat(range[0]), parseFloat(range[1])]]
        } else {
          const value = ShowFilterValue[attribute]
          const range = value ? value.split('-') : Common.GetJSON(item.filter_options)

          return [attribute, [parseFloat(range[0]), parseFloat(range[1])]]
        }
      })
  )
  const RangeSliderValues = Object.fromEntries(
    props.filterData[0]
      .filter((item: { input_type: string }) => item.input_type === Enums.Controltype.RangeSlider)
      .map((item: any) => {
        const attribute = item.attribute_code
        const filterOptions = item.filter_options.map((x: any) => x.option_value)

        const marks = Object.fromEntries(
          filterOptions.map((val: string, index: number) => [index, val])
        )

        const selected = ShowFilterValue[attribute]?.split(',') || []

        const values = selected.length
          ? [
              filterOptions.indexOf(selected[0]),
              filterOptions.indexOf(selected[selected.length - 1]) + 1
            ]
          : [0, filterOptions.length]

        return [attribute, { marks, values }]
      })
  )
  const { settingOptions } = useSelector((state: AppState) => state.settings)
  const [PriceSign, setPriceSign] = useState<any>('')
  const [active, setactive] = useState<boolean>(false)

  useEffect(() => {
    const currency = JSON.parse(Common.decryptData(localStorage.getItem(Messages.Currency))) || []
    if (currency?.length > 0) {
      var selectedCountry: any = Cookies.get(Messages.Country)
      const priceSign = currency.filter((cu: any) => cu.id === parseInt(selectedCountry))[0]
        .currency_symbol
      setPriceSign(priceSign)
    }
  }, [])

  useEffect(() => {
    setShowFilterValue(props.queryParams)
  }, [props.queryParams])

  useEffect(() => {
    const obj: any = {}

    searchParams.forEach((value, key) => {
      obj[key] = value
    })

    setShowFilterValue(obj)
  }, [searchParams])

  const checkSlugForStyle = () => {
    const style = pathname.split('/')[2]
    const styleOptions = Filters.filter((x: any) => x.attribute_code === Messages.Filters.Style)
    if (styleOptions !== undefined && styleOptions.length !== 0) {
      const isExists = styleOptions[0].filter_options.filter(
        (x: any) => x.option_value.toLowerCase().replaceAll(' ', '-') === style.toLowerCase()
      )
      if (isExists.length > 0) return true
    }
    return false
  }

  const changeFilters = (e: any, filterName: any, inputType: any) => {
    if (inputType === Enums.Controltype.Slider) {
      let currentRangeValue = SliderValues[filterName]
      let FromValue = parseFloat(e[0]).toFixed(2)
      let ToValue = parseFloat(e[1]).toFixed(2)
      if (filterName.indexOf('_from') > -1) {
        filterName = filterName.replace('_from', '')
        currentRangeValue = SliderValues[filterName]
        FromValue = parseFloat(e.target.value.replace(/[^\d]/g, '')).toFixed(2)
        ToValue = parseFloat(currentRangeValue[1]).toFixed(2)
      } else if (filterName.indexOf('_to') > -1) {
        filterName = filterName.replace('_to', '')
        currentRangeValue = SliderValues[filterName]
        ToValue = parseFloat(e.target.value.replace(/[^\d]/g, '')).toFixed(2)
        FromValue = parseFloat(currentRangeValue[0]).toFixed(2)
      }
      if (parseFloat(FromValue) < parseFloat(ToValue)) {
        if (FromValue === currentRangeValue[0] && ToValue === currentRangeValue[1]) return
        setShowFilterValue({
          ...ShowFilterValue,
          [filterName]: FromValue + '-' + ToValue
        })
        // add the filter in URL
        sessionStorage.setItem(Messages.ReloadPage, JSON.stringify(false))
        const currentParams = new URLSearchParams(searchParams.toString())
        currentParams.set(filterName, `${FromValue}-${ToValue}`)
        router.push(`${pathname}?${currentParams.toString()}`, { scroll: false })
      }
    } else if (inputType === Enums.Controltype.Radio) {
      setShowFilterValue({
        ...ShowFilterValue,
        [filterName]: e.target.attributes['data-name'].value
      })
      sessionStorage.setItem(Messages.ReloadPage, JSON.stringify(false))
      const params = new URLSearchParams(searchParams.toString())
      params.set(filterName, e.target.getAttribute('data-name'))

      const newUrl =
        filterName === 'style' && checkSlugForStyle() && props.category.parent_slug !== pathname
          ? props.category.parent_slug
          : pathname

      router.push(`${newUrl}?${params.toString()}`, { scroll: false })
    } else {
      const selectedValues: any = []
      const selectedValueLables: any = []
      const rangeSliderValues = Object.entries(RangeSliderValues[filterName].marks)
      const rangeSliderOptions = Filters.filter(
        (item: any) => item.attribute_code === filterName
      )[0].filter_options
      rangeSliderValues.filter(function ([key, value]: any) {
        if (key >= parseInt(e[0]) && key < parseInt(e[1])) {
          const val = rangeSliderOptions.filter((item: any) => item.option_value === value)
          if (val != null) {
            selectedValues.push(parseInt(val[0].option_id))
            selectedValueLables.push(val[0].option_value)
          }
        }
        return true
      })
      if (selectedValues.length > 0) {
        setShowFilterValue({
          ...ShowFilterValue,
          [filterName]: selectedValueLables.join(',')
        })
        sessionStorage.setItem(Messages.ReloadPage, JSON.stringify(false))

        const newParams = new URLSearchParams(searchParams.toString())
        newParams.set(filterName, selectedValueLables.join(','))
        router.push(`${pathname}?${newParams.toString()}`, { scroll: false })
      } else {
        removeFilter(filterName, inputType)
      }
    }
  }

  const removeParameterFromURL = (param: string) => {
    const newParams = new URLSearchParams(searchParams.toString())
    sessionStorage.setItem(Messages.ReloadPage, 'false')
    newParams.delete(param)
    router.replace(`?${newParams.toString()}`, { scroll: false })
  }

  const removeFilter = (field: any, inputType: any = '') => {
    const sortBy =
      searchParams.get('sort_by') !== undefined && searchParams.get('sort_by') !== null
        ? searchParams.get('sort_by')
        : props.queryParams?.sort_by

    if (field === 'all') {
      if (
        checkSlugForStyle() &&
        props.category.parent_slug !== pathname &&
        searchParams.get('sort_by') !== null &&
        searchParams.get('sort_by') !== undefined
      ) {
        router.push(`${props.category.parent_slug}?sort_by=${sortBy}`)
      } else if (
        searchParams.get('sort_by') !== null &&
        searchParams.get('sort_by') !== undefined
      ) {
        router.push(`${pathname}?sort_by=${sortBy}`, { scroll: false })
      } else {
        if (checkSlugForStyle() && props.category.parent_slug !== pathname) {
          router.push(props.category.parent_slug)
        } else {
          router.push(pathname, { scroll: false })
        }
      }
    } else {
      if (field === 'style' || field === 'shape') {
        sessionStorage.setItem(Messages.ReloadPage, JSON.stringify(false))
        const currentUrl = Common.GetPathname()
        const splitCurrentUrl = currentUrl.split('/')
        
        if (splitCurrentUrl.length === 4) {
          if (field === 'shape') {
            splitCurrentUrl.splice(2, 1)
          } else if (field === 'style') {
            splitCurrentUrl.splice(3, 1)
          }
          const url = splitCurrentUrl.join('/')
          router.push(`${url}?${searchParams.toString()}`, { scroll: false })
        } else if (splitCurrentUrl.length === 3) {
          if (props.category.setting_type === 1 && props.category.is_mto_category === 0) {
            const newParams = new URLSearchParams(searchParams.toString())
            newParams.delete(field)
            if (field === 'shape') {
              newParams.delete('carat') // remove carat filter when can be set shape filter is removed
            }
            let newurL = settingOptions.filter(
              (item: any) => item.hj_key === 'ENGAGEMENT_RING_ALL_SETTING_URL'
            )[0].hj_value
            router.push(`${newurL}?${newParams.toString()}`, { scroll: false })
          } else router.push(props.category.parent_slug, { scroll: false })
        }
      } else {
        removeParameterFromURL(field)
      }
    }
  }

  const changeSort = (e: any) => {
    const params = new URLSearchParams(window.location.search)
    params.set('sort_by', e.target.value)

    sessionStorage.setItem(Messages.ReloadPage, 'false')
    router.push(`${pathname}?${params.toString()}`, { scroll: false })
  }

  const toggle = () => {
    setactive((prev) => !prev)
  }
  return (
    <>
      {Filters.length > 0 && (
        <div>
          <div className="filter-section">
            <div className="container">
              <div className="filter-listing-bar">
                <div className="desktop-filter row g-3 row-cols-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-6 justify-content-center filter-listing-bar-row">
                  {Filters.map((filter: any, index: number) => (
                    <div
                      key={index}
                      className="col filter-listing-col"
                    >
                      <div
                        className={
                          filter.attribute_name + '-filter-listing-bar filter-listing-bar-repeat'
                        }
                      >
                        <div className="filter-listing-bar-title">
                          {ShowFilterValue[filter.attribute_code] !== undefined && (
                            <span className="filter-selected"></span>
                          )}
                          <span>{filter.attribute_name}</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-chevron-down"
                          >
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </div>

                        <div className="filter-listing-icons">
                          <div className="mobile-filter-label">
                            <div className="mobile-filter-close">
                              <button
                                type="button"
                                className="btn-close"
                              ></button>
                            </div>
                            <span className="mobile-filter-title">{filter.attribute_name}</span>
                            <div className="mobile-filter-reset">Clear</div>
                          </div>

                          {filter.input_type === Enums.Controltype.Radio && (
                            <ul className="filter-listing-icons-list">
                              {filter.filter_options.map((option: any, idx: number) => (
                                <li
                                  key={idx}
                                  className="filter-listing-icons-repeat"
                                >
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name={filter.attribute_code}
                                      data-name={option.option_value}
                                      value={option.option_id}
                                      id={filter.attribute_code + '_w_' + option.option_id}
                                      onChange={(e) =>
                                        changeFilters(e, filter.attribute_code, filter.input_type)
                                      }
                                      checked={
                                        ShowFilterValue[filter.attribute_code] ===
                                        option.option_value
                                      }
                                    />
                                    <label
                                      className="form-check-label filter-listing-icon-name"
                                      htmlFor={filter.attribute_code + '_w_' + option.option_id}
                                    >
                                      <div className="filter-listing-icon">
                                        <img
                                          src={option.image}
                                          alt={option.option_value}
                                          width={filter.attribute_name === 'Style' ? 40 : ''}
                                        />
                                      </div>
                                      {option.option_value}
                                    </label>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}

                          {filter.input_type === Enums.Controltype.Slider && (
                            <div>
                              <Slider
                                key={filter.attribute_code + Math.random()}
                                range
                                defaultValue={[
                                  parseFloat(SliderValues[filter.attribute_code][0]),
                                  parseFloat(SliderValues[filter.attribute_code][1])
                                ]}
                                onChangeComplete={(e) =>
                                  changeFilters(e, filter.attribute_code, filter.input_type)
                                }
                                step={1}
                                min={
                                  filter.attribute_code === 'price'
                                    ? priceMin
                                    : parseFloat(filter.filter_options[0])
                                }
                                max={
                                  filter.attribute_code === 'price'
                                    ? priceMax
                                    : parseFloat(filter.filter_options[1])
                                }
                                allowCross={false}
                                handleRender={handleSlider}
                              />
                              <div className="carat-input-field">
                                <div className="carat-input-label">
                                  {SliderValues[filter.attribute_code] !== undefined && (
                                    <NumericFormat
                                      thousandSeparator={true}
                                      prefix={filter.attribute_code === 'price' ? PriceSign : ''}
                                      value={parseFloat(SliderValues[filter.attribute_code][0])}
                                      displayType="input"
                                      type="text"
                                      valueIsNumericString={true}
                                      width={10}
                                      allowNegative={false}
                                      onKeyUp={(e) => {
                                        if (e.key === 'Enter') {
                                          changeFilters(
                                            e,
                                            filter.attribute_code + '_from',
                                            filter.input_type
                                          )
                                        }
                                      }}
                                      onBlur={(e) =>
                                        changeFilters(
                                          e,
                                          filter.attribute_code + '_from',
                                          filter.input_type
                                        )
                                      }
                                    />
                                  )}
                                  <input type="hidden" />
                                </div>
                                <div className="carat-input-label">
                                  {SliderValues[filter.attribute_code] !== undefined && (
                                    <NumericFormat
                                      thousandSeparator={true}
                                      prefix={filter.attribute_code === 'price' ? PriceSign : ''}
                                      value={parseFloat(SliderValues[filter.attribute_code][1])}
                                      displayType="input"
                                      type="text"
                                      valueIsNumericString={true}
                                      allowNegative={false}
                                      onKeyUp={(e) => {
                                        if (e.key === 'Enter') {
                                          changeFilters(
                                            e,
                                            filter.attribute_code + '_to',
                                            filter.input_type
                                          )
                                        }
                                      }}
                                      onBlur={(e) =>
                                        changeFilters(
                                          e,
                                          filter.attribute_code + '_to',
                                          filter.input_type
                                        )
                                      }
                                    />
                                  )}
                                  <input type="hidden" />
                                </div>
                              </div>
                            </div>
                          )}

                          {filter.input_type === Enums.Controltype.RangeSlider && (
                            <Slider
                              key={filter.attribute_code + Math.random()}
                              range
                              allowCross={false}
                              min={0}
                              max={
                                Object.keys(RangeSliderValues[filter.attribute_code].marks).length
                              }
                              step={1}
                              marks={RangeSliderValues[filter.attribute_code].marks}
                              defaultValue={RangeSliderValues[filter.attribute_code].values}
                              onChangeComplete={(e) => {
                                changeFilters(e, filter.attribute_code, filter.input_type)
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="container">
              <div className="filter-listing-result setting-filter-listing-result">
                <ul>
                  {Object.keys(props.CustomFilters).length > 0 &&
                    Object.keys(props.CustomFilters).map((key: any, i: number) => {
                      const value = ShowFilterValue?.[key]
                      if (!value || value === '' || (Array.isArray(value) && value.length === 0)) {
                        return null
                      }
                      if (
                        props.CustomFilters[key].input_type &&
                        props.CustomFilters[key].input_type !== Enums.Controltype.Slider
                      ) {
                        return (
                          <li key={i}>
                            <a
                              className="filter-result-repeat"
                              onClick={() => removeFilter(key, props.CustomFilters[key].input_type)}
                            >
                              <span className="text-capitalize">
                                {key + ': ' + ShowFilterValue[key]}
                              </span>
                              <img
                                src={Common.setImagePath('assets/images/icon/cancel.svg')}
                                alt="close"
                              />
                            </a>
                          </li>
                        )
                      } else if (props.CustomFilters[key].input_type === Enums.Controltype.Slider) {
                        return (
                          <li key={i}>
                            <a
                              className="filter-result-repeat"
                              onClick={() => removeFilter(key, props.CustomFilters[key].input_type)}
                            >
                              {key + ': '}&nbsp;
                              <NumericFormat
                                thousandSeparator={true}
                                prefix={key === 'price' ? PriceSign : ''}
                                value={SliderValues[key][0]}
                                displayType="text"
                              />{' '}
                              -{' '}
                              <NumericFormat
                                thousandSeparator={true}
                                prefix={key === 'price' ? PriceSign : ''}
                                value={SliderValues[key][1]}
                                displayType="text"
                              />
                              <img
                                src={Common.setImagePath('assets/images/icon/cancel.svg')}
                                alt="close"
                              />
                            </a>
                          </li>
                        )
                      } else if (key == 'carat') {
                        return (
                          <li key={i}>
                            <a className="filter-result-repeat pe-none disabled opacity-75 disabled">
                              <span className="text-capitalize">
                                {key + ': ' + ShowFilterValue[key]}
                              </span>
                              <img
                                src={Common.setImagePath('assets/images/icon/cancel.svg')}
                                alt="close"
                              />
                            </a>
                          </li>
                        )
                      } else {
                        return null
                      }
                    })}
                  {Object.keys(ShowFilterValue).filter((key) => key !== 'sort_by').length > 0 && (
                    <li className="clear-filter">
                      <a onClick={() => removeFilter('all')}>Clear Filter</a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div>
            {props.category ? (
              <div className="container setting-filter-section">
                <div className="product-listing-section-title">
                  <h1>{props.category?.title}</h1>
                  <div
                    onClick={toggle}
                    className={
                      active ? 'active listing-description-section' : 'listing-description-section'
                    }
                  >
                    {parse(props.category?.description)}
                  </div>
                  {props.category?.category_banner !== null &&
                    props.category?.category_banner[0].DesktopBannerImage !== '' &&
                    props.category?.category_banner[0].MobileBannerImage !== '' && (
                      <div className="row justify-content-center">
                        <div className="col-md-12 col-xl-12">
                          <div className="cat-listing-banner mt-3">
                            {screenWidth > 768 ? (
                              <img
                                src={props.category?.category_banner[0].DesktopBannerImage}
                                alt="desktop_main_image"
                                width={700}
                              />
                            ) : (
                              <img
                                src={props.category?.category_banner[0].MobileBannerImage}
                                alt="mobile_main_image"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                </div>
                <GoogleReviewBanner
                  PositionCenter={true}
                  ShowKeyword={true}
                />
              </div>
            ) : (
              <div className="container">
                <div className="product-listing-section-title">
                  <h1>
                    <Skeleton
                      highlightColor={'#f1ebee'}
                      width={200}
                      height={30}
                      baseColor={'#f1f1f1'}
                    />
                  </h1>
                  <p>
                    <Skeleton
                      highlightColor={'#f1ebee'}
                      width={500}
                      height={50}
                      baseColor={'#f1f1f1'}
                    />
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {MobileFilters.length > 0 && (
        <div className="container-fluid">
          <div
            className="mobile-filter"
            id="mobile-filter"
          >
            <div className="filters-toggle">
              Filters
              <img
                src={Common.setImagePath('assets/images/filters.svg')}
                alt="sort"
              />
            </div>
            <div className="mobile-filter-header">
              <div className="mobile-filter-close">
                <button
                  type="button"
                  className="btn-close"
                ></button>
              </div>
              <span className="mobile-filter-title">
                <u>All Filters</u>
              </span>
              <div className="mobile-filter-reset">
                {Object.keys(ShowFilterValue).filter((key) => key !== 'sort_by').length > 0 && (
                  <span onClick={() => removeFilter('all')}>Reset</span>
                )}
              </div>
            </div>

            <div className="mobile-filter-body">
              <Swiper
                effect="fade"
                simulateTouch={false}
                allowTouchMove={false}
                cssMode={true}
                pagination={true}
                modules={[Navigation, Pagination]}
                slidesPerView={1}
                navigation={true}
                loop={false}
                speed={800}
                spaceBetween={25}
              >
                {MobileFilters.length > 0 &&
                  MobileFilters.map((filter: any, index: number) => {
                    return (
                      <SwiperSlide key={index}>
                        {filter.map((item: any, innerIndex: number) => {
                          if (item.input_type === Enums.Controltype.Radio) {
                            return (
                              <div
                                key={innerIndex}
                                className="col filter-listing-col"
                              >
                                <div
                                  className={
                                    'filter-listing filter-' + item.attribute_code + '-list'
                                  }
                                >
                                  <div className="filter-name">{item.attribute_name}</div>
                                  <ul>
                                    {Common.GetJSON(item.filter_options).map((option: any) => (
                                      <li
                                        className="filter-listing-repeat"
                                        key={option.option_id}
                                      >
                                        <div
                                          className={
                                            option.image !== ''
                                              ? 'form-check form-filter-check'
                                              : 'form-check filter-button-type form-filter-check'
                                          }
                                        >
                                          <input
                                            className="form-check-input"
                                            id={item.attribute_code + '_' + option.option_id}
                                            type="radio"
                                            name={item.attribute_id}
                                            data-name={option.option_value}
                                            value={option.option_id}
                                            onChange={(e) =>
                                              changeFilters(e, item.attribute_code, item.input_type)
                                            }
                                            checked={
                                              ShowFilterValue[item.attribute_code] ===
                                              option.option_value
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor={item.attribute_code + '_' + option.option_id}
                                          >
                                            <div className="filter-thumbnail">
                                              <img
                                                width="70"
                                                src={option.image}
                                                alt={option.option_value}
                                              />
                                            </div>
                                            <div className="filter-label">
                                              {option.option_value}
                                            </div>
                                          </label>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            )
                          } else if (item.input_type === Enums.Controltype.RangeSlider) {
                            return (
                              <div
                                className="col filter-listing-col"
                                key={innerIndex}
                              >
                                <div
                                  className={
                                    'filter-listing filter-' + item.attribute_code + '-list'
                                  }
                                >
                                  <div className="filter-name mb-3">{item.attribute_name}</div>

                                  <Slider
                                    key={filter.attribute_code + Math.random()}
                                    range
                                    allowCross={false}
                                    min={0}
                                    max={
                                      Object.keys(RangeSliderValues[item.attribute_code].marks)
                                        .length
                                    }
                                    step={1}
                                    marks={RangeSliderValues[item.attribute_code].marks}
                                    defaultValue={RangeSliderValues[item.attribute_code].values}
                                    onChangeComplete={(e) => {
                                      changeFilters(e, item.attribute_code, item.input_type)
                                    }}
                                  />
                                </div>
                              </div>
                            )
                          } else if (item.input_type === Enums.Controltype.Slider) {
                            return (
                              <div
                                className="col filter-listing-col"
                                key={innerIndex}
                              >
                                <div
                                  className={
                                    'filter-listing filter-' + item.attribute_code + '-list'
                                  }
                                >
                                  <div className="filter-name mb-3">{item.attribute_name}</div>
                                  {SliderValues !== undefined &&
                                  SliderValues[item.attribute_code][1] > 0 ? (
                                    <Slider
                                      key={item.attribute_code + Math.random()}
                                      range
                                      defaultValue={[
                                        parseFloat(SliderValues[item.attribute_code][0]),
                                        parseFloat(SliderValues[item.attribute_code][1])
                                      ]}
                                      onChangeComplete={(e) =>
                                        changeFilters(e, item.attribute_code, item.input_type)
                                      }
                                      step={1}
                                      min={
                                        item.attribute_code === 'price'
                                          ? priceMin
                                          : parseFloat(item.filter_options[0])
                                      }
                                      max={
                                        item.attribute_code === 'price'
                                          ? priceMax
                                          : parseFloat(item.filter_options[1])
                                      }
                                      allowCross={false}
                                      handleRender={handleSlider}
                                    />
                                  ) : null}
                                  <div className="carat-input-field">
                                    <div className="carat-input-label">
                                      {SliderValues[item.attribute_code] !== undefined && (
                                        <NumericFormat
                                          thousandSeparator={true}
                                          prefix={item.attribute_code === 'price' ? PriceSign : ''}
                                          value={SliderValues[item.attribute_code][0]}
                                          displayType="input"
                                          type="text"
                                          valueIsNumericString={true}
                                          allowNegative={false}
                                          onKeyUp={(e) => {
                                            if (e.key === 'Enter') {
                                              changeFilters(
                                                e,
                                                item.attribute_code + '_from',
                                                item.input_type
                                              )
                                            }
                                          }}
                                          onBlur={(e) =>
                                            changeFilters(
                                              e,
                                              item.attribute_code + '_from',
                                              item.input_type
                                            )
                                          }
                                        />
                                      )}
                                      <input type="hidden" />
                                    </div>
                                    <div className="carat-input-label">
                                      {SliderValues[item.attribute_code] !== undefined && (
                                        <NumericFormat
                                          thousandSeparator={true}
                                          prefix={item.attribute_code === 'price' ? PriceSign : ''}
                                          value={SliderValues[item.attribute_code][1]}
                                          displayType="input"
                                          type="text"
                                          valueIsNumericString={true}
                                          allowNegative={false}
                                          onKeyUp={(e) => {
                                            if (e.key === 'Enter') {
                                              changeFilters(
                                                e,
                                                item.attribute_code + '_to',
                                                item.input_type
                                              )
                                            }
                                          }}
                                          onBlur={(e) =>
                                            changeFilters(
                                              e,
                                              item.attribute_code + '_to',
                                              item.input_type
                                            )
                                          }
                                        />
                                      )}
                                      <input type="hidden" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          } else return null
                        })}
                      </SwiperSlide>
                    )
                  })}
              </Swiper>
            </div>

            <div className="mobile-filter-footer"></div>
          </div>

          <div className="mobile-filter-overlay"></div>
        </div>
      )}

      <div className="container mt-5">
        <div className="select-sort-by">
          <select
            className="form-select"
            onChange={(e) => changeSort(e)}
            value={props.queryParams?.sort_by ? props.queryParams?.sort_by : 'price_low_high'}
          >
            <option
              className="option"
              value="newest"
            >
              Newest
            </option>
            <option
              className="option"
              value="price_low_high"
            >
              Price Low to High
            </option>
            <option
              className="option"
              value="price_high_low"
            >
              Price High to Low
            </option>
            {/* <option
                  className="option"
                  value="best_seller"
                >
                  Best Seller
                </option> */}
          </select>
        </div>
      </div>
    </>
  )
}

export default Filter
